<template>
  <!-- Dialog -->

  <v-dialog v-model="viewModel.dialog.value" persistent max-width="1200px">
    <v-card>
      <!-- Title Section -->
      <v-card-title class="d-flex justify-between align-center">
        <span class="text-subtitle-1 font-weight-bold">
          Cronograma de Pagos
        </span>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="viewModel.loading_pdf.value"
          variant="flat"
          icon
          @click="viewModel.closeDialog()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <!-- Account List -->
      <v-card-text>
        <v-container fluid class="pa-0">
          <v-row dense>
            <v-col cols="12">
              <v-card flat>
                <v-row>
                  <v-col cols="12">
                    <v-table
                      density="compact"
                      height="400px"
                      fixed-header
                      style="
                        border-left: 7px solid rgb(var(--v-theme-primary), 0.4);
                      "
                    >
                      <thead>
                        <tr>
                          <th class="text-left">Mes</th>
                          <th class="text-left">Vencimiento</th>
                          <th class="text-left" style="min-width: 100px">
                            Interés
                          </th>
                          <th class="text-left" style="min-width: 100px">
                            Capital
                          </th>
                          <th class="text-left" style="min-width: 100px">
                            Aporte
                          </th>
                          <th class="text-left" style="min-width: 100px">
                            Seguro
                          </th>
                          <th class="text-left" style="min-width: 100px">
                            Cuota
                          </th>
                          <th class="text-left" style="min-width: 100px">
                            Saldo capital
                          </th>
                          <th class="text-left">Cancelado</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, idx) in viewModel.schedules.value"
                          :key="`schedule-${idx}`"
                        >
                          <td class="text-caption">{{ item.numcuota }}</td>
                          <td class="text-caption">
                            {{ viewModel.formatDate(item.fechacuota) }}
                          </td>
                          <td class="text-caption">
                            {{ viewModel.coin.value }}
                            {{ viewModel.getFloat(item.interes) }}
                          </td>
                          <td class="text-caption">
                            {{ viewModel.coin.value }}
                            {{ viewModel.getFloat(item.capital) }}
                          </td>
                          <td class="text-caption">
                            {{ viewModel.coin.value }}
                            {{ viewModel.getFloat(item.aporte) }}
                          </td>
                          <td class="text-caption">
                            {{ viewModel.coin.value }}
                            {{ viewModel.getFloat(item.seguro) }}
                          </td>
                          <td class="text-caption">
                            {{ viewModel.coin.value }}
                            {{ viewModel.getFloat(item.cuota) }}
                          </td>
                          <td class="text-caption">
                            {{ viewModel.coin.value }}
                            {{ viewModel.getFloat(item.saldo) }}
                          </td>
                          <td class="text-caption">
                            {{ viewModel.isCanceled(item.es_cancelado) }}
                          </td>
                        </tr>
                      </tbody>
                    </v-table>
                  </v-col>
                  <v-col class="text-end">
                    <v-btn
                      flat
                      color="primary"
                      class="text-none"
                      :loading="viewModel.loading_pdf.value"
                      @click.prevent="viewModel.downloadSchedule"
                    >
                      <v-icon class="mr-2">mdi-download</v-icon>
                      Descargar Cronograma</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { defineExpose } from "vue";
import SchedulesDialogViewModel from "@/viewmodels/dialogs/SchedulesDialogViewModel";
import { Credit } from "@/models/Credit";

const viewModel = new SchedulesDialogViewModel();

// Exponemos directamente los métodos sin usar `bind`
defineExpose({
  openDialog: (credit: Credit) => viewModel.openDialog(credit),
  closeDialog: () => viewModel.closeDialog(),
});
</script>
